import ReactEcharts from "echarts-for-react";
import "echarts-liquidfill";

function SorefsisChart(props) {
  const realValue = props.realValue;
  const limit = props.limit;
  let score=(realValue/limit)

  const phasevar = Math.PI / 2// phase of wave, in radian system
  const option = {
    series: [
      {
        type: "liquidFill",
        name: 'Έχουν καταναλωθεί',
        center: ['50%', '35%'],
        radius: '80%',
        amplitude: '5%',
        waveLength: '200%', 
        phase: phasevar,
        data: [{value: score, direction: 'left'}, score], // 2 waves at different heights
        /* { value: score-0.03, direction: 'left' } for different direction of wave*/
        period: function (value, index) { // milliseconds that it takes to move forward a wave-length
          // This function is called two times, each for a data item in series.
          //`index` is 0, 1.
          return 8000//back to front wave: 4s
        },
        silent: true,
        color: ['rgba(23, 130, 213, 1)', 'rgba(0, 51, 117, 1)'],
        backgroundStyle: {
          borderWidth: 2,
          borderColor: '#003375',
          color: 'white'
        },
        itemStyle: {
          shadowBlur: 0
        },
        outline: { show: false },
        label: {
          //rich text style
          //'{rich style name|text to have this style}'
          formatter: function(param) {
            return [
            '{text|' + param.seriesName + '}',
            '{tiny| }',
            '{sum|' + (realValue).toLocaleString('el-GR', {
                style: 'currency',
                currency: 'EUR'
            }).slice(0,-1) + '€}'
          ].join('\n')},
          rich: {
            text: {
              fontSize: '0.7rem',
              fontWeight: 500,
              color: 'rgba(23, 130, 213, 1)'
            },
            sum: {
              fontSize: '1.5rem',
              fontWeight: 300,
            },
            tiny: {
                fontSize: '0.7rem'
            }
          },
          color: '#003375'
        }
      }
    ]
  }

  //to change wave color if score 100%
  if (score >= 1) {
    const deepred = 'rgba(150, 0, 10, 1)'
    const softred = 'rgba(150, 10, 30, 0.7)'
    const palered = '#FC9C6C'
    option.series[0].color = [softred, deepred]
    option.series[0].backgroundStyle.borderColor = deepred
    option.series[0].label.color =  deepred
    option.series[0].label.rich.text.color = palered
  }

  return <ReactEcharts option={option} />;
}

export default SorefsisChart;